import { useState } from 'react';
import { useIntl } from 'react-intl';
import { ThemeProvider } from 'styled-components';

import { D2CTheme, FontSizes, FontWeights, Text } from '@calm-web/design-system';

import { useAnalytics } from '@/hooks/analytics';
import { useRouterPush } from '@/hooks/utils/useRouterPush';

import { messages } from './messages';
import { Copy, Cta } from './styles';

const Ineligible = () => {
	const { formatMessage } = useIntl();
	const routerPush = useRouterPush();
	const { logEvent } = useAnalytics();

	const [isRouting, setIsRouting] = useState(false);

	const onPress = async () => {
		logEvent({
			eventName: 'Screen : Exited',
			eventProps: {
				button: 'cta',
			},
		});
		setIsRouting(true);
		await routerPush('/subscribe');
	};

	return (
		<ThemeProvider theme={D2CTheme}>
			<Copy>
				<Text noMargin color="gray5" el="h1" weight={FontWeights.Demi} size={FontSizes['2xl']}>
					{formatMessage(messages.heading)}
				</Text>
				<Text noMargin color="gray5" el="h2" weight={FontWeights.Regular} size={FontSizes.base}>
					{formatMessage(messages.subheading)}
				</Text>
			</Copy>
			<Cta fullWidth isLoading={isRouting} onPress={onPress} backgroundColor="blue2" textColor="white">
				{formatMessage(messages.cta)}
			</Cta>
		</ThemeProvider>
	);
};

export default Ineligible;
